interface QuickSuggestionsProps {
  locale:   string;
  onSelect: (text: string) => void;
}

const suggestions = {
  en: [
    'Your services',
    'Your projects',
    'Contact you',
    'Tech stack',
  ],
  ar: [
    'خدماتك',
    'مشاريعك',
    'تواصل معك',
    'تقنياتك',
  ],
} as const;

export function QuickSuggestions({ locale, onSelect }: QuickSuggestionsProps) {
  const items = suggestions[locale === 'ar' ? 'ar' : 'en'];

  return (
    <div className="flex flex-wrap gap-2 p-3 border-b border-(--border)">
      {items.map((s) => (
        <button
          key={s}
          onClick={() => onSelect(s)}
          className="
            px-3 py-1.5 text-xs rounded-full
            border border-(--border) text-(--muted)
            hover:border-primary-500 hover:text-primary-500 hover:bg-primary-500/5
            transition-colors duration-180 cursor-pointer
          "
        >
          {s}
        </button>
      ))}
    </div>
  );
}

export default QuickSuggestions;
